import gql from 'graphql-tag';

export default gql`
    query GetAllNotifications($input: NotificationInput, $offset: Int) {
        getAllNotifications(input: $input, offset: $offset) {
            notificationDateTime
            loadId
            driverId
            secondaryDriverId
            notificationType
            notificationJSON
        }
    }
`;
